import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import './Screenshots.scss';

const screenshots = [
  { src: '/images/index/paper_01.png', title: '' },
  { src: '/images/index/paper_02.png', title: '' },
  { src: '/images/index/paper_03.png', title: '' },
  { src: '/images/index/paper_04.png', title: '' },
];

const appScreenshots = [
  { src: '/images/index/appinfo_01.jpg', title: '' },
  { src: '/images/index/appinfo_02.jpg', title: '' },
  { src: '/images/index/appinfo_03.jpg', title: '' },
];

const Screenshots = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  return (
    <section className="screenshots section">
      <div className="container">
        <header className="screenshots__header">
          <h2 className="screenshots__title">위 영상 이외의 학생별 오답관리 스크린샷 미리보기</h2>
          {/* <p className="screenshots__subtitle">시험지 생성, 채점, 오답 기능, 모바일 앱까지</p> */}
        </header>

        <div className="screenshots__list">
          {screenshots.map((screenshot, index) => (
            <div key={index} className="screenshots__item" onClick={() => setSelectedImage(screenshot)}>
              <img src={screenshot.src} alt={screenshot.title} />
            </div>
          ))}
        </div>

        <div className="screenshots__apps">

          <div className="screenshots__apps-grid">
            {appScreenshots.map((screenshot, index) => (
              <div key={index} className="screenshots__app-item" onClick={() => setSelectedImage(screenshot)}>
                <img src={screenshot.src} alt={screenshot.title} />
                <span className="screenshots__app-label">{screenshot.title}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <AnimatePresence>
        {selectedImage && (
          <motion.div
            className="screenshots__modal"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            onClick={() => setSelectedImage(null)}
          >
            <motion.div
              className="screenshots__modal-content"
              initial={{ scale: 0.9 }}
              animate={{ scale: 1 }}
              exit={{ scale: 0.9 }}
              onClick={(e) => e.stopPropagation()}
            >
              <button className="screenshots__modal-close" onClick={() => setSelectedImage(null)}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <line x1="18" y1="6" x2="6" y2="18" />
                  <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
              </button>
              <img src={selectedImage.src} alt={selectedImage.title} />
              <p className="screenshots__modal-title">{selectedImage.title}</p>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </section>
  );
};

export default Screenshots;

